
<template>
    <div >
    <div class="row">
        <div class="col">

        <Dropdown
            v-model="selectedCountry"
            :options="countries"
            optionLabel="name"
            :filter="true"
            :placeholder="TR.select"
            :showClear="true"
        >
            <template #value="slotProps">
                <div class="country-item country-item-value" v-if="slotProps.value">
                    <div>{{slotProps.value.name}}</div>
                </div>
                <span v-else>{{slotProps.placeholder}}</span>
            </template>
            <template #option="slotProps">
                <div class="country-item">
                    <div>{{slotProps.option.name}}</div>
                </div>
            </template>
        </Dropdown>

        </div>
        <div class="col">

        <Dropdown
            v-model="selectedCountry"
            :options="countries"
            optionLabel="name"
            :filter="true"
            :placeholder="TR.select"
            :showClear="true"
        >
            <template #value="slotProps">
                <div class="country-item country-item-value" v-if="slotProps.value">
                    <div>{{slotProps.value.name}}</div>
                </div>
                <span v-else>{{slotProps.placeholder}}</span>
            </template>
            <template #option="slotProps">
                <div class="country-item">
                    <div>{{slotProps.option.name}}</div>
                </div>
            </template>
        </Dropdown>

        </div>
        </div>

        <PickList v-model="products" :filter="true" listStyle="height:500px" data-key="id">
            <template #sourceheader>Available</template>
            <template #targetheader>Selected</template>
            <template #item="slotProps">
                <div class="product-item">
                    <div class="image-container">
                        <img
                            src="https://www.primefaces.org/wp-content/uploads/2020/05/placeholder.png"
                        />
                    </div>
                    <div class="product-list-detail">
                        <h6 class="mb-2">{{slotProps.item.name}}</h6>
                        <i class="pi pi-tag product-category-icon"></i>
                        <span class="product-category">{{slotProps.item.category}}</span>
                    </div>
                    <div class="product-list-action">
                        <h6 class="mb-2">${{slotProps.item.phone}}</h6>
                        <span
                            :class="'product-badge status-'+slotProps.item.inventoryStatus.toLowerCase()"
                        >{{slotProps.item.inventoryStatus}}</span>
                    </div>
                </div>
                <!-- <ListBox
                v-model="selectedProduct"
                :multiple="true"
                :options="datas"
                :filter="true"
                optionLabel="name"
                listStyle="max-height:250px"
                style="width:15rem"
                filterPlaceholder="s"
            >
                <template #option="slotProps1">
                    <div class="country-item">
                        <div>{{slotProps1.option.name}}</div>
                    </div>
                </template>
                </ListBox>-->
            </template>
        </PickList>
    </div>
</template>

<script>
    import { ref, onMounted, watchEffect } from "vue";
    // import ProductService from './service/ProductService';
    import { useStore } from "@/store";

    import PickList from "primevue/picklist";
    import Dropdown from "primevue/dropdown";

    export default {
        name: 'PickList',
        props: ["data"],
        components: {
            PickList,
            Dropdown,
        },
        setup(props) {
            const store = useStore();

            const TR = ref(null);

            const selectedProduct = ref(null);
            const products = ref(null);
            const datas = ref(null);
            const selectedCountry = ref(null);

            const countries = ref([
                { name: "Australia", code: "AU" },
                { name: "Brazil", code: "BR" },
                { name: "China", code: "CN" },
                { name: "Egypt", code: "EG" },
                { name: "France", code: "FR" },
                { name: "Germany", code: "DE" },
                { name: "India", code: "IN" },
                { name: "Japan", code: "JP" },
                { name: "Spain", code: "ES" },
                { name: "United States", code: "US" },
            ]);

            watchEffect(() => {
                TR.value = store.getTranslation();
            });

            onMounted(() => {
                datas.value = props.data.data.second;
                products.value = [
                    props.data.data.first || [],
                    props.data.data.second || [],
                ];
            });

            return {
                TR,
                selectedProduct,
                products,
                datas,
                countries,
                selectedCountry,
            };
        },
    };
</script>

<style lang="scss" scoped>
    .product-item {
        display: flex;
        align-items: center;
        padding: 0.5rem;
        width: 100%;

        img {
            width: 75px;
            box-shadow: 0 3px 6px rgba(0, 0, 0, 0.16), 0 3px 6px rgba(0, 0, 0, 0.23);
            margin-right: 1rem;
        }

        .product-list-detail {
            flex: 1 1 0;
        }

        .product-list-action {
            display: flex;
            flex-direction: column;
            align-items: flex-end;
        }

        .product-category-icon {
            vertical-align: middle;
            margin-right: 0.5rem;
        }

        .product-category {
            vertical-align: middle;
            line-height: 1;
        }
    }

    @media screen and (max-width: 576px) {
        .product-item {
            flex-wrap: wrap;

            .image-container {
                width: 100%;
                text-align: center;
            }

            img {
                margin: 0 0 1rem 0;
                width: 100px;
            }
        }
    }
</style>